import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Bookmark, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { StepChips } from "./campaignModel";

export const SaveTemplateModal = ({ open, onClose, campaign: c, onSave }) => {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setName(c?.name ? `${c.name} cadence` : "");
  }, [open, c?.name]);

  const save = async () => {
    if (!name.trim()) return toast.error("Give your template a name");
    setSaving(true);
    const ok = await onSave(name.trim());
    setSaving(false);
    if (ok) onClose();
  };

  const cfg = c?.cadenceConfig || {};
  const stepCount = cfg.steps || (cfg.stepLabels || []).length;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="save-template-modal"
        >
          <motion.div
            className="glass-card p-6 max-w-md w-full space-y-4"
            initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-2">
              <Bookmark className="h-5 w-5 text-ism-teal" />
              <h3 className="text-lg text-white font-medium">Save Cadence as Template</h3>
            </div>
            <p className="text-xs text-gray-500">
              Reuse this cadence structure ({stepCount} steps · {c?.cadenceStyle || "consultative"}) on future campaigns.
            </p>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Template name (e.g., Enterprise 5-touch)" className="bg-white/5 border-white/10 text-white" data-testid="template-name-input" autoFocus />
            <StepChips cadenceConfig={cfg} />
            <div className="flex justify-end gap-2 pt-2">
              <Button onClick={onClose} variant="ghost" size="sm" className="text-gray-400 hover:text-white">Cancel</Button>
              <Button onClick={save} disabled={saving} size="sm" className="bg-ism-teal hover:bg-ism-teal/90 text-black font-medium" data-testid="confirm-save-template-btn">
                {saving ? <><Loader2 className="h-3.5 w-3.5 animate-spin mr-1" /> Saving...</> : <><Save className="h-3.5 w-3.5 mr-1" /> Save Template</>}
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
